import Vue from 'vue'
import Vuex from 'vuex'
// import VuexPersist from 'vuex-persist'

// const vuexLocal = new VuexPersist({
//     // key: 'vuexStore',
//     storage: window.sessionStorage
// })

Vue.use(Vuex)

const store = new Vuex.Store({
//   plugins: [vuexLocal.plugin],
  state: {
    uuid: '', // 详情期数
    userShow: false,
    orderInfos: {}, // 活动订单详情
    searchTitle: '', // 搜索关键词
    shopData: {}, // 商城订单详情,
    shopNum: 0, // 购买数量
    readList: [],
    unreadList: [],
    unreadMessage: 0,
    readTotal: 0,
    systemName: '',
    enterpriseName: '',
    imgUrl: '',
    logoUrl: '',
    lateScoreTime: '',
    colorList : ['#039443', '#47aa34', '#b2ce25', '#f0e928','#f4c500','#e47615','#dc4a15','#d72228','#ba323e','#8a244b','#522663','#202779','#1d396f','#1a5561','#116b56','#166958','#147b4d']
  },
  mutations: {
    uuid (state, res) {
      this.state.uuid = res
    },
    userShow (state, res) {
      this.state.userShow = res
    },
    orderInfos (state, res) {
      this.state.orderInfos = res
    },
    searchTitle (state, res) {
      this.state.searchTitle = res
    },
    shopData (state, res) {
      this.state.shopData = res
    },
    readList (state, res) {
      this.state.readList = res
    },
    unreadList (state, res) {
      this.state.unreadList = res
    },
    unreadMessage (state, res) {
      this.state.unreadMessage = res
    },
    readTotal (state, res) {
      this.state.readTotal = res
    },
    shopNum (state, res) {
      this.state.shopNum = res
    },
    getSystemName(state, data) {
      state.systemName = data
    },
    getEnterpriseName(state, data) {
      state.enterpriseName = data
    },
    getImgUrl(state, data) {
      state.imgUrl = data
    },
    getLogoUrl(state, data) {
      state.logoUrl = data
    },
    getLateScoreTime(state, data) {
      state.lateScoreTime = data
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js